<template>
  <v-container class="pa-0" fluid>
    <!-- <material-card icon="mdi-clipboard-text" inline title="Enrollment request listing"> -->
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" lg="3" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  Enrollment request listing
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="9" class="my-0 mr-0 py-0">
            <v-card-text  class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
               <v-card-actions>
                 <a @click="$router.back()">
                   <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back </v-btn>
                   <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;">
                   <v-icon>mdi-arrow-left</v-icon>
                   </v-btn>
                 </a>
              </v-card-actions>
            </v-card-text>
          </v-col>
          <v-col cols="12" lg="9" md="9" class="my-0 py-0">
            <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <v-text-field
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width:350px;"
        ></v-text-field>
        <router-link slot="right" :to="{ name: 'addTeacherEnrollment' }">
          <v-btn elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
            <v-icon left>mdi-plus</v-icon>
            Add
          </v-btn>
        </router-link>
      </v-card-text>
          </v-col>
        </v-row>
      <!-- <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <v-text-field
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width:350px;"
        ></v-text-field>
        <router-link slot="right" :to="{ name: 'addTeacherEnrollment' }">
          <v-btn elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
            <v-icon left>mdi-plus</v-icon>
            Add
          </v-btn>
        </router-link>
      </v-card-text> -->
      <v-divider class=" my-0 " />
      <v-data-table :headers="headers" :items="itemData" :items-per-page="10" :search="search">
        <template v-slot:item.actions="{ item }">
          <router-link :to="{ name: 'approveTeacherEnrollment', params: { enrollID: item.id } }">
            <v-btn v-if="isWrite" class="px-2 ml-1 white--text ma-1" min-width="0" small>
              <v-icon small color="black"> mdi-eye</v-icon>
            </v-btn>
          </router-link>
          <router-link :to="{ name: 'editTeacherEnrollment', params: { enrollID: item.id } }">
            <v-btn class="px-2 ml-1 white--text ma-1" color="success" min-width="0" small>
              <v-icon small> mdi-pencil</v-icon>
            </v-btn>
          </router-link>
        </template>
      </v-data-table>
      </v-card>
    <!-- </material-card> -->

    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import constants from '@/utils/constants'
// import MaterialCard from '@/components/template/MaterialCard'
import _ from 'lodash'
// import moment from 'moment'
import { mapGetters } from 'vuex'
import Utils from '@/utils'

export default {
  name: 'OnlineClassList',
  // components: { MaterialCard },
  data () {
    return {
      data: [],
      search: '',
      headers: [
        { text: 'Center Name', sortable: true, value: 'franchiseeListing' },
        { text: 'Teachers Count', sortable: true, value: 'trainingRequestStaffMaps.length' },
        { text: 'Training Topic', sortable: false, value: 'training.name' },
        { text: 'Status', sortable: false, value: 'status' },
        { text: 'Action', value: 'actions', align: 'center', sortable: false }
      ],
      itemData: [],
      isLoading: false,
      isWrite: false
    }
  },

  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {},
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  async created () {
    try {
      this.isWrite = await Utils.helper.getIsWriteFun(this.$route)
      await this.getEnrollmentData()
    } catch (e) {
      const errorMessage = (e && e.response && e.response.data.message) || e.message
      this.errMsg(errorMessage)
    }
  },
  methods: {
    restoreItem: async function (data) {
      try {
        this.isLoading = true
        await http.get(`${constants.API_URL}/api/teacher-training/assessment/restore/${data.id}`)
        this.isLoading = false
        this.getEnrollmentData()
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    deleteItem: async function (data) {
      try {
        this.isLoading = true
        await http.get(`${constants.API_URL}/api/teacher-training/assessment/delete/${data.id}`)
        this.isLoading = false
        this.getEnrollmentData()
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getEnrollmentData: async function () {
      try {
        this.isLoading = true
        const { data } = await http.post(`${constants.API_URL}/api/teacher-training/request/get`, {})
        this.isLoading = false
        if (!_.isEmpty(data)) {
          this.itemData = data
        }

        this.itemData.filter(function (e) {
          if (e.trainingRequestFranchiseeMaps) {
            let franchisees = e.trainingRequestFranchiseeMaps
            let franchiseeList = []
            franchisees.filter(function (k) {
              if (k.franchisee) {
                franchiseeList.push(k.franchisee.companyName)
              }
            })

            e.franchiseeListing = franchiseeList.join(', ')
          }
          return e
        })
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    onFranchiseeChange: async function () {
      try {
        if (!this.inProgress) {
          this.inProgress = true
          if (this.franchisee) {
            this.franchiseeID = this.franchisee.id
          } else {
            this.franchiseeID = ''
          }
          if (this.academicYear) {
            this.academicYearID = this.academicYear.id
          } else {
            this.academicYearID = ''
          }
          this.inProgress = false
        }
      } finally {
        this.inProgress = false
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
